import { useEffect, useState } from 'react';

interface UseSentenceRotatorProps {
  mainSentence: string;
  sentences: string[];
}

export const useSentenceRotator = ({
  mainSentence,
  sentences,
}: UseSentenceRotatorProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % sentences.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return {
    mainSentence,
    secondSentence: sentences[index],
  };
};
